import { getRoute } from '@utils/route';

export const CANCER_QUOTE_PAYMENT_PAGE_URL = '/cancer-insurance-quote-payment/:orderNumber/:billingId';

type RouteParams = {
  orderNumber: string;
  billingId: number;
};

export const routeCancerQuotePaymentPage = (routeParams: RouteParams) => getRoute(CANCER_QUOTE_PAYMENT_PAGE_URL, { routeParams });
